import { render, staticRenderFns } from "./FeedBack.vue?vue&type=template&id=6a4a4939&"
import script from "./FeedBack.vue?vue&type=script&lang=js&"
export * from "./FeedBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a4a4939')) {
      api.createRecord('6a4a4939', component.options)
    } else {
      api.reload('6a4a4939', component.options)
    }
    module.hot.accept("./FeedBack.vue?vue&type=template&id=6a4a4939&", function () {
      api.rerender('6a4a4939', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/assignmentBin/FeedBack.vue"
export default component.exports